import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { setSession } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthGoogleCallback() {
    const nav = useNavigate();
    // useRef (not state) so StrictMode's double-effect can't post twice.
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
        const sessionId = params.get("session_id");
        // Clean the URL immediately so refreshing won't retry.
        window.history.replaceState(null, "", window.location.pathname);

        if (!sessionId) {
            toast.error("Missing Google session — please try signing in again.");
            nav("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId });
                setSession(data.access_token, data.user);
                if (data.is_new_user) {
                    toast.success(`Welcome, ${data.user.full_name}! Let's finish your profile.`);
                } else {
                    toast.success(`Welcome back, ${data.user.full_name}`);
                }
                if (data.profile_incomplete) {
                    nav("/signup/complete-profile", { replace: true });
                } else {
                    nav("/doctor", { replace: true });
                }
            } catch (err) {
                const detail = err?.response?.data?.detail;
                const msg = typeof detail === "string" ? detail : "Google sign-in failed";
                toast.error(msg);
                nav("/login", { replace: true });
            }
        })();
    }, [nav]);

    return (
        <div
            className="min-h-screen flex items-center justify-center bg-[#F5F8FA]"
            data-testid="google-callback-loading"
        >
            <div className="text-center">
                <div className="inline-block h-10 w-10 border-4 border-[#0F766E]/20 border-t-[#0F766E] rounded-full animate-spin mb-4" />
                <div className="text-[#123B5D] font-semibold">Signing you in with Google…</div>
                <div className="text-sm text-[#17212B]/60 mt-1">You&apos;ll be redirected in a moment.</div>
            </div>
        </div>
    );
}
